"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function view() {
    var _this = this;
    return {
        state: {
            jobUnavailableText: csod.locales.get("Job Unavailable", "This job is not available.")
        },
        initialize: function () {
            _this.props.initMethod();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            _this.view.state.jobUnavailableText = csod.locales.get("Job Unavailable", "This job is not available.");
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onApply: this.props.onApply,
            onSave: this.props.onSave,
            onShare: this.props.onShare,
            onInfoWindowClick: this.props.onInfoWindowClick,
            setBannerContentHeight: this.props.setBannerContentHeight
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetails/View.js
// module id = 965
// module chunks = 0